import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { LoanCarActivateComponent }        from './loan-car-schedule.activate.component';
import { LoanCarCreateComponent }          from './loan-car-create.component';
import { LoanCarReturnComponent }          from './loan-car-return.component';
import { LoanCarReviewComponent }          from './loan-car-review.component';
import { LoanCarScheduleActionsComponent } from './loan.car.actions.component';
import { LoanCarScheduleComponent }        from './loan-car-schedule.component';
import { LoanCarStartComponent }           from './loan-car-start.component';
import { LoanVehiclesComponent }           from './loan-car-schedule.vehicles.component';
import { LoanCarScheduleStates }           from './loan-car-schedule.states';
import { LoanCarScheduleStatusPipe }       from './loan-car-schedule.status.pipe';
import { LoanCarService }                  from './loan-car.service';
import { LoanCarVehicleComponent }         from './loan-car.vehicle.component';
import { SharedModule }                    from '../shared/shared.module';
import { TableModule }                    from '../table/table.module';

@NgModule({
  declarations: [
    LoanCarActivateComponent,
    LoanCarCreateComponent,
    LoanCarReturnComponent,
    LoanCarReviewComponent,
    LoanCarScheduleActionsComponent,
    LoanCarScheduleComponent,
    LoanCarScheduleStatusPipe,
    LoanCarStartComponent,
    LoanCarVehicleComponent,
    LoanVehiclesComponent
  ],
  entryComponents: [
    LoanCarCreateComponent,
    LoanCarReturnComponent,
    LoanCarReviewComponent,
    LoanCarScheduleActionsComponent,
    LoanCarStartComponent,
    LoanCarVehicleComponent,
    LoanVehiclesComponent
  ],
  exports: [
    LoanCarScheduleStatusPipe,
  ],
  imports: [
    SharedModule,
    TableModule,
    UIRouterModule.forChild({ states: LoanCarScheduleStates })
  ],
  providers: [
    LoanCarScheduleStatusPipe,
    LoanCarService,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'loanStatus',
      useClass: LoanCarScheduleStatusPipe
    }
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class LoanCarScheduleModule {}